import { render, staticRenderFns } from "./custom-datatable.vue?vue&type=template&id=55e0db94&"
import script from "./custom-datatable.vue?vue&type=script&lang=js&"
export * from "./custom-datatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports